'use strict';
define(['../base/Class', '../utils/CommonUtil'], function (Class, CommonUtil) {


    var Position = {

        TRANSFORM: function () {
            return this.testProp(['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
        },


        testProp: function (props) {
            var style = document.documentElement.style;

            for (var i = 0; i < props.length; i++) {
                if (props[i] in style) {
                    return props[i];
                }
            }
            return false;
        },


        setPosition: function (el, point) {
            el._pos = point;
            if (CommonUtil.Browser().any3d) {
                this.setTransform(el, point);
            } else {
                el.style.left = point[0] + 'px';
                el.style.top = point[1] + 'px';
            }
        },
        getPosition: function (el) {
            return el._pos || [0, 0]// [el.offsetLeft, el.offsetTop];
        },


        setTransform: function (el, offset, scale) {
            var pos = offset || new Point(0, 0);
            el.style[this.TRANSFORM()] =
                (CommonUtil.Browser().ie3d ? 'translate(' + pos[0] + 'px,' + pos[1] + 'px)' : 'translate3d(' + pos[0] + 'px,' + pos[1] + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
        }

    }

    var lang = {
        extend: function (dest) {
            var i, j, len, src;

            for (j = 1, len = arguments.length; j < len; j++) {
                src = arguments[j];
                for (i in src) {
                    dest[i] = src[i];
                }
            }
            return dest;
        },
        create: Object.create || (function () {
            function F() {
            }

            return function (proto) {
                F.prototype = proto;
                return new F();
            };
        })()
    };
    (function () {
        // inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/

        function getPrefixed(name) {
            return window['webkit' + name] || window['moz' + name] || window['ms' + name];
        }

        var lastTime = 0;

        // fallback for IE 7-8
        function timeoutDefer(fn) {
            var time = +new Date(),
                timeToCall = Math.max(0, 16 - (time - lastTime));

            lastTime = time + timeToCall;
            return window.setTimeout(fn, timeToCall);
        }

        function bind(fn, obj) {
            var slice = Array.prototype.slice;

            if (fn.bind) {
                return fn.bind.apply(fn, slice.call(arguments, 1));
            }

            var args = slice.call(arguments, 2);

            return function () {
                return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
            };
        }

        var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer,
            cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
                getPrefixed('CancelRequestAnimationFrame') || function (id) {
                    window.clearTimeout(id);
                };

        lang.requestAnimFrame = function (fn, context, immediate) {
            if (immediate && requestFn === timeoutDefer) {
                fn.call(context);
            } else {
                return requestFn.call(window, bind(fn, context));
            }
        };
        lang.cancelAnimFrame = function (id) {
            if (id) {
                cancelFn.call(window, id);
            }
        };
    })();
    // G.bind = function (fn, obj) {
    //     var slice = Array.prototype.slice;
    //
    //     if (fn.bind) {
    //         return fn.bind.apply(fn, slice.call(arguments, 1));
    //     }
    //
    //     var args = slice.call(arguments, 2);
    //
    //     return function () {
    //         return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
    //     };
    // }

    var clazz = Class.extend({

        option: {
            clickTolerance: 3
        },
        draggableStyle: {
            dragging: {
                cursor: "move"
            },
            defaults: {
                cursor: "default"
            }
        },

        initialize: function (element, dragStartTarget, preventOutline, options) {
            Class.setOptions(this, options);
            this._element = element; //element instanceof $ ? element : $(element);
            this._dragStartTarget = dragStartTarget || element;
            // this._element.style.position = 'fixed';

            this.START = CommonUtil.Browser().touch ? 'touchstart mousedown' : 'mousedown';
            this.END = {
                mousedown: 'mouseup',
                touchstart: 'touchend',
                pointerdown: 'touchend',
                MSPointerDown: 'touchend'
            }
            this.MOVE = {
                mousedown: 'mousemove',
                touchstart: 'touchmove',
                pointerdown: 'touchmove',
                MSPointerDown: 'touchmove'
            }
        },


        enable: function () {
            if (this._enabled)return;


            $(this._dragStartTarget).bind(this.START, {self: this}, this._onDown)
            // this._dragStartTarget.addEventListener(this.START, this._onDown(this))
            this._enabled = true;
        },

        disable: function () {
            if (!this._enabled) return;
            if (clazz._dragging === this) {
                this.finishDrag();
            }

            $(this._dragStartTarget).unbind(this.START, this._onDown)
            // this._dragStartTarget.removeListener(this.START, this._onDown(this))
            this._enabled = false;
            this._moved = false;

        }
        ,
        _onDown: function (event) {
            var e = event.originalEvent;
            var self = event.data.self;
            if (e._simulated || !self._enabled)return;
            self._moved = false;
            if (clazz._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches))return;
            clazz._dragging = self;
            if (self._moving)return;
            var first = e.touches ? e.touches[0] : e;
            self._startPoint = [first.clientX, first.clientY];
            $(document).bind(self.MOVE[e.type], {self: self}, self._onMove);
            $(document).bind(self.END[e.type], {self: self}, self._onUp);
            if (self._dragStartTarget&&self._dragStartTarget.style)
                self._dragStartTarget.style.cursor = self.draggableStyle.dragging.cursor;

        }
        ,
        _onMove: function (event) {
            var e = event.originalEvent;
            var self = event.data.self;
            if (e._simulated || !self._enabled) {
                return;
            }
            if (e.touches && e.touches.length > 1) {
                self._moved = true;
                return;
            }
            var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e);
            var np = [first.clientX, first.clientY];
            var sp = self._startPoint;
            var offset = [np[0] - sp[0], np[1] - sp[1]];
            if (!offset[0] && !offset[1])return;
            if (Math.abs(offset[0]) + Math.abs(offset[1]) < self.options.clickTolerance)return;
            if (e.preventDefault) e.preventDefault();
            if (!self._moved) {
                self._moved = true;
                var pos = Position.getPosition(self._element);
                self._startPos = [pos[0] - offset[0], pos[1] - offset[1]]
                self._lastTarget = e.target || e.srcElement;
                if ((window.SVGElementInstance) && (self._lastTarget instanceof SVGElementInstance)) {
                    self._lastTarget = self._lastTarget.correspondingUseElement;
                }

            }

            self._newPos = [self._startPos[0] + offset[0], self._startPos[1] + offset[1]]
            self._moving = true;

            lang.cancelAnimFrame(self._animRequest);//???
            self._lastEvent = e;
            self._updatePosition()
            // self._animRequest = G.Util.requestAnimFrame(self._updatePosition, self, true);
        },
        _onUp: function (event) {
            var e = event.originalEvent;
            var self = event.data.self;
            console.log('up')
            if (e._simulated || !self._enabled) {
                return;
            }
            self.finishDrag();
            self._dragStartTarget.style.cursor = self.draggableStyle.defaults.cursor;//dragging;

        }
        ,
        _updatePosition: function () {
            // var h2 = this._element.offsetTop;
            // var w2 = this._element.offsetLeft;
            // var h1 = this._element.offsetHeight;
            // var w1 = this._element.offsetWidth;
            // var w = document.body.clientWidth - w1 - w2;
            // var h = document.body.clientHeight - h1 - h2;
            // this._newPos[0] = this._newPos[0] < w ? this._newPos[0] : w;
            // this._newPos[1] = this._newPos[1] < h ? this._newPos[1] : h;
            // console.log([w, w1, w2, this._newPos[0], h, h1, h2, this._newPos[1]])
            // this._newPos[0] = this._newPos[0] + w2 > 0 ? this._newPos[0] : -w2;
            // this._newPos[1] = this._newPos[1] + h2 > 0 ? this._newPos[1] : -h2;
            Position.setPosition(this._element, this._newPos);

        }
        ,
        setDragTarget: function (el) {
            if (el)
                this._dragStartTarget = el;
        },
        getDragTarget: function () {
            return this._dragStartTarget;
        },
        finishDrag: function () {
            console.log('finishDrag')
            if (this._lastTarget) {
                this._lastTarget = null;
            }
            for (var i in this.MOVE) {
                $(document).unbind(this.MOVE[i], this._onMove);
                $(document).unbind(this.END[i], this._onUp);
            }
            if (this._moved && this._moving) {
                lang.cancelAnimFrame(this._animRequest);
            }
            this._moving = false;
            clazz._dragging = false;
        }

    })
    return clazz;
})